// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__gCDus","inputWrap":"Table_inputWrap__1F8o1","col":"Table_col__1PJ9d","bmiTooltip":"Table_bmiTooltip__2GeXb"};